import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CommentSendBlock from './form/CommentSendBlock'
import CommentList from './CommentList'
import { useEffect } from 'react'
import { setCommentList } from '../../store/commentSlice'

const Comments = ({ comments, supplyOrderId, supplyBillId, supplierId, writeOffActId }) => {

	const commentsStore = useSelector(state => state.comment.list)
	const dispatch = useDispatch()

	useEffect(() => {
		setCommentsInStore()
	}, [comments])

	const setCommentsInStore = () => {
		dispatch(setCommentList(comments))
	}

  return (
    <div className='commentsBlock'>
        <CommentList 
            comments={commentsStore}
        />

        <CommentSendBlock 
			supplyOrderId={supplyOrderId}
			supplyBillId={supplyBillId}
			supplierId={supplierId}
			writeOffActId={writeOffActId}
		/>
    </div>
  )
}

export default Comments